import { H1 } from "../../components/Text/Text";
import { UserT } from "../../models/models";
import { PopupT } from "../../store/slices/popupSlice";
import ContactInfoValidationPopupBody from "./ContactInfoValidationPopupBody";

import "./styles.css";

export default (userItem: UserT): Omit<PopupT, "id"> => ({
  // Stable key so the popup store de-dups any duplicate trigger (defence in depth alongside the
  // single-mount gate hook).
  key: "contact-info-validation",
  header: <H1>Personal contact info</H1>,
  body: <ContactInfoValidationPopupBody userItem={userItem} />,
  className: "wrapperWithoutCloseButton",
});
